// extracted by mini-css-extract-plugin
module.exports = {"container":"FloatingContainer_container___xr5h"};